import Soumission from './views/Soumission.vue'

const route = [
  {
    path: '/mes-soumissions',
    name: 'soumission',
    component: Soumission,
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      title: 'Mes soumissions',
      lang_code: "my_submissions",
      role: ['A','R','C','I'],
      customer_required: true,
      order: 8
    }
  }
]

export default route